var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F0F1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0173 15.011H23.7613L21.3755 12.6237C20.6074 11.8556 19.6507 11.3033 18.6014 11.0222C17.5522 10.7411 16.4474 10.7412 15.3982 11.0224C14.349 11.3036 13.3923 11.8561 12.6244 12.6244C11.8564 13.3926 11.3042 14.3494 11.0233 15.3987M10.2388 22.733V18.989M10.2388 18.989H13.9828M10.2388 18.989L12.6238 21.3762C13.3918 22.1443 14.3486 22.6967 15.3978 22.9778C16.4471 23.2588 17.5518 23.2588 18.6011 22.9775C19.6503 22.6963 20.6069 22.1438 21.3749 21.3756C22.1429 20.6073 22.6951 19.6505 22.976 18.6012M23.7613 11.267V15.0095",
    stroke: "#9CA37F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.d25734afcb24bb5f4b86a72baad2ae9d.svg";
export { ForwardRef as ReactComponent };